import React, { Component } from 'react';
import Select from 'react-select';
import InputText,{InputSelect} from '../../../commonModules/interface/form-input-inline';
import { Grid, Button, Box } from '@material-ui/core';

class FormMatch extends Component {
    state = { 
        
    }

    createProductList = () => {// select product options in Form
        const list = [{value:"", label:"Choisissez un produit"}]
        const { PRODUCTS } = this.props
        if( PRODUCTS ){
            Object.values(PRODUCTS).map( product => {   
                list.push (       
                    {value:product.id, label:`${product.ref} (${product.marque} - ${product.name})`, ref: product.ref} 
                )
            })
            return list
        } else {
            return false
        }
    }

    render() {
        const { step } = this.props;
        return (
            <Box>

                {step === 1 &&
                <Grid container spacing={2}>
                    <Grid item xs={12}>
                        <InputText 
                            name="match_dest_email"
                            value={this.props.match_dest_email}
                            error={this.props.errors.match_dest_email}
                            errorClass={!!this.props.errors.match_dest_email}
                            change={this.props.handleChange}
                            title="Compte Destinataire"
                            placeholder="Entrez l'email du compte destinataire"
                            required
                        />                    
                    </Grid>
                    
                    <Grid item xs={12}>
                        <Button variant="contained" color="secondary" disabled={this.props.loading} onClick={ this.props.validateStep1 }>Valider</Button>
                    </Grid>
                </Grid> 
                    
                }
                
                {this.props.match_dest_account && step === 2 &&
                    
                    <Grid container spacing={2}>
                        <Grid item xs={12}>
                            <Box p={2}>
                                <h4>Compte destinataire: {this.props.match_dest_email || "blabla@gmail.com"}</h4>
                            </Box>
                        </Grid>
                        <Grid item xs={12}>
                            <InputSelect
                                label="Produit"
                                value={this.props.match_src_product}
                                onChange={option => this.props.handleSelect(option, "match_src_product")}
                                style={{border: '0'}}
                                options={this.createProductList()}
                                error={this.props.errors.match_src_product}
                            />
                            {/* <div 
                                className={"form-group col-sm-12 " + (this.props.errors.match_src_product ? "has-error" : "")}
                            >
                                <label className="control-label">Produit</label>  
                                {/*<Select
                                    value={this.props.match_src_productDisplay}
                                    onChange={option => this.props.handleSelect(option, "match_src_product")}
                                    style={{border: '0'}}
                                    options={this.createProductList()}
                                />
                                <small className="help-block" >{this.props.errors.match_src_product}</small>
                            </div>                                                 */}
                        </Grid>

                        <Grid item xs={12}>
                            <InputText 
                                name="match_dest_ref"
                                value={this.props.match_dest_ref}
                                error={this.props.errors.match_dest_ref}
                                change={this.props.handleChange}
                                title="Réference produit"
                                placeholder="Reference produit dans le compte destinaire"
                            />                    
                        </Grid>
    
                        <Grid item xs={12}>
                            
                            <Button 
                                variant="contained" 
                                color="secondary" 
                                onClick={this.props.findProductInfo}
                                disabled={this.props.loading}
                            >Associer</Button>

                            <Button
                                color="secondary"
                                onClick={() => this.props.changeStep(1) }
                            >Retour</Button>
                        </Grid>
                    </Grid>
                }
            </Box>
                
        );
    }
}

export default FormMatch;